<template>
  <v-container fluid>
    <!-- Título -->
    <v-row class="mb-4 mt-2">
      <v-col>
        <h1 class="display-1 font-weight-bold primary--text">
          <v-icon large color="red" class="mr-3">mdi-robot</v-icon>
          Auditor 24/7 - Panel de Alertas
        </h1>
      </v-col>
      <v-col cols="12" md="4" class="text-right">
        <v-btn color="primary" @click="cargarAlertas" class="mr-2">
          <v-icon left>mdi-refresh</v-icon>
          Actualizar
        </v-btn>
        <v-btn color="success" @click="exportarExcel">
          <v-icon left>mdi-microsoft-excel</v-icon>
          Exportar
        </v-btn>
      </v-col>
    </v-row>

    <!-- Resumen Ejecutivo -->
    <v-row class="mb-6" align="stretch">
      <v-col cols="12" sm="6" md="3" lg="2" class="d-flex">
        <v-card color="purple darken-2" dark class="transition-swing flex-grow-1" elevation="6" hover>
          <v-card-title class="headline">
            <v-icon large left>mdi-clock-alert</v-icon>
            En Riesgo Twilio
          </v-card-title>
          <v-card-text class="display-2 font-weight-bold">
            {{ resumen.riesgoTwilio }}
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3" lg="2" class="d-flex">
        <v-card color="blue-grey darken-2" dark class="transition-swing flex-grow-1" elevation="6" hover>
          <v-card-title class="headline">
            <v-icon large left>mdi-message-badge</v-icon>
            Pendientes
          </v-card-title>
          <v-card-text class="display-2 font-weight-bold">
            {{ totalPendientes }}
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3" lg="2" class="d-flex">
        <v-card color="blue darken-2" dark class="transition-swing flex-grow-1" elevation="6" hover>
          <v-card-title class="headline">
            <v-icon large left>mdi-message-check</v-icon>
            Leidas
          </v-card-title>
          <v-card-text class="display-2 font-weight-bold">
            {{ leidas }}
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3" lg="2" class="d-flex">
        <v-card color="red darken-4" dark class="transition-swing flex-grow-1" elevation="6" hover>
          <v-card-title class="headline">
            <v-icon large left>mdi-fire-alert</v-icon>
            Críticas
          </v-card-title>
          <v-card-text class="display-2 font-weight-bold">
            {{ resumen.criticas }}
            <v-chip v-if="tendenciaCriticas !== 0" small :color="tendenciaCriticas < 0 ? 'green' : 'orange'"
              class="ml-2">
              {{ tendenciaCriticas < 0 ? '↓' : '↑' }} {{ Math.abs(tendenciaCriticas) }} </v-chip>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- <v-col cols="12" sm="6" md="3" lg="2" class="d-flex">
        <v-card color="orange darken-3" dark class="transition-swing flex-grow-1" elevation="6" hover>
          <v-card-title class="headline">
            <v-icon large left>mdi-trending-down</v-icon>
            Calidad
          </v-card-title>
          <v-card-text class="display-1 font-weight-bold">
            {{ resumen.calidad }}
          </v-card-text>
        </v-card>
      </v-col> -->

      <v-col cols="12" sm="6" md="3" lg="2" class="d-flex">
        <v-card color="amber darken-3" dark class="transition-swing flex-grow-1" elevation="6" hover>
          <v-card-title class="headline">
            <v-icon large left>mdi-alert</v-icon>
            Advertencias
          </v-card-title>
          <v-card-text class="display-1 font-weight-bold">
            {{ resumen.advertencias }}
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3" lg="2" class="d-flex">
        <v-card color="green accent-4" dark class="transition-swing flex-grow-1" elevation="6" hover>
          <v-card-title class="headline">
            <v-icon large left>mdi-trophy</v-icon>
            Positivas Hoy
          </v-card-title>
          <v-card-text class="display-2 font-weight-bold">
            {{ resumen.positivas }}
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Gráfico Sparkline (Fase 3) -->
    <v-row class="mb-4">
      <v-col cols="12">
        <v-card>
          <v-card-title>Minigráfico de alertas en la última semana</v-card-title>
          <v-card-text>
            <!-- <v-sparkline :value="sparklineData" color="red" line-width="2" padding="16" smooth auto-draw></v-sparkline> -->
            <v-row align="center">
              <v-col cols="6">
                <div class="headline red--text">Críticas</div>
                <v-sparkline :value="sparklineCriticas" color="red" line-width="2" padding="16" smooth
                  auto-draw></v-sparkline>
              </v-col>
              <v-divider vertical></v-divider>
              <v-col cols="6">
                <div class="headline green--text">Positivas</div>
                <v-sparkline :value="sparklinePositivas" color="green" line-width="2" padding="16" smooth
                  auto-draw></v-sparkline>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>


    <!-- Filtros -->
    <v-row class="mb-4">
      <v-col cols="12" md="4">
        <v-select v-model="filtroTipo" :items="tiposFiltro" label="Filtrar por tipo" outlined clearable></v-select>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field v-model="buscarLead" label="Buscar" outlined prepend-inner-icon="mdi-magnify"
          clearable></v-text-field>
      </v-col>
    </v-row>

    <!-- Tabla de Alertas -->
    <v-data-table :headers="headers" :items="alertasFiltradas" :items-per-page="15" class="elevation-1"
      :item-class="rowClass" sort-by="created_at" :sort-desc="true">
      <!-- Prioridad -->
      <template v-slot:item.tipo="{ item }">
        <v-chip :color="getColorTipo(item.tipo)" dark small>
          <v-icon small left>{{ getIconTipo(item.tipo) }}</v-icon>
          {{ item.tipo }}
        </v-chip>
      </template>

      <!-- Valor Numérico con chip de color -->
      <template v-slot:item.valor_numeric="{ item }">
        <v-chip v-if="item.valor_numeric !== null" small :color="getColorValor(item.valor_numeric, item.unidad)" dark
          class="font-weight-bold">
          {{ formatValor(item.valor_numeric, item.unidad) }}
        </v-chip>
        <span v-else>-</span>
      </template>

      <!-- Lead -->
      <template v-slot:item.usuario_chat="{ item }">
        <span class="primary--text font-weight-bold">
          {{ formatWpp(item.usuario_chat) }}
        </span>
      </template>

      <!-- Acciones -->
      <template v-slot:item.acciones="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small fab color="success" @click="marcarLeida(item.id)"
              :disabled="item.leido === 1 || item.tipo == 'POSITIVA'" v-on="on" v-bind="attrs" class="mr-2">
              <v-icon small>mdi-check</v-icon>
            </v-btn>
          </template>
          <span>Marcar como leída</span>
        </v-tooltip>

        <!-- <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small fab color="green" :href="`https://wa.me/${formatWppRaw(item.usuario_chat)}`" target="_blank"
              v-on="on" v-bind="attrs">
              <v-icon small>mdi-whatsapp</v-icon>
            </v-btn>
          </template>
          <span>Abrir chat en WhatsApp</span>
        </v-tooltip> -->
      </template>

      <!-- Fecha -->
      <template v-slot:item.created_at="{ item }">
        {{ formatFecha(item.created_at) }}
      </template>
    </v-data-table>

    <v-snackbar v-model="snackbar" :color="snackbarType" :timeout="3000">
      {{ snackbarText }}
      <v-btn text @click="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from 'axios'

export default {
  name: 'AuditorPanel',

  data() {
    return {
      snackbar: false,
      snackbarType: '',
      snackbarText: '',
      alertas: [],
      alertasHistoria: [], // Para sparkline y tendencia
      resumen: {
        criticas: 0,
        calidad: 0,
        advertencias: 0,
        positivas: 0,
        riesgoTwilio: 0
      },
      resumenAyer: { criticas: 0 },
      filtroTipo: null,
      buscarLead: '',
      tiposFiltro: ['CRITICA', 'ADVERTENCIA', 'POSITIVA'],
      // tiposFiltro: ['CRITICA', 'CALIDAD', 'ADVERTENCIA', 'POSITIVA'],
      sparklinePositivas: [],
      sparklineCriticas: [],

      headers: [
        { text: 'Prioridad', value: 'tipo', width: '120px' },
        { text: 'Tiempo transcurrido', value: 'valor_numeric', width: '140px' },
        { text: 'Detalle', value: 'detalle_extra', width: '180px' },
        { text: 'Título', value: 'titulo' },
        { text: 'Mensaje', value: 'mensaje' },
        { text: 'Lead wpp', value: 'usuario_chat', width: '120px' },
        { text: 'Vendedor', value: 'nombre_vendedora' },
        { text: 'Fecha', value: 'created_at', width: '140px' },
        { text: 'Acciones', value: 'acciones', sortable: false, width: '140px' }
      ]
    }
  },

  computed: {
    alertasFiltradas() {
      let filtradas = this.alertas.filter(alerta => alerta.leido === 0)

      if (this.filtroTipo) {
        filtradas = filtradas.filter(a => a.tipo === this.filtroTipo)
      }

      if (this.buscarLead) {
        const termino = this.buscarLead.toLowerCase().trim()
        filtradas = filtradas.filter(a => {
          const camposTexto = [
            String(a.usuario_chat),
            a.nombre_vendedora,
            a.titulo || '',
            a.mensaje || '',
            a.detalle_extra || '',
            a.valor_numeric || '',
            a.prioridad || ''
          ].join(' ').toLowerCase()
          return camposTexto.includes(termino)
        })
      }

      return filtradas
    },

    totalPendientes() {
      return this.resumen.criticas + this.resumen.calidad + this.resumen.advertencias
    },

    leidas() {
      return this.alertas.length - this.totalPendientes
    },

    tendenciaCriticas() {
      return this.resumen.criticas - this.resumenAyer.criticas
    },

    sparklineData() {
      // Simulación simple: últimas 12 horas (puedes mejorar con datos reales)
      const horas = 12
      const data = []
      const ahora = new Date()
      for (let i = horas - 1; i >= 0; i--) {
        const hora = new Date(ahora)
        hora.setHours(ahora.getHours() - i)
        const count = this.alertasHistoria.filter(a => {
          const fecha = new Date(a.created_at)
          return fecha.getHours() === hora.getHours() && a.tipo === 'CRITICA'
        }).length
        data.push(count)
      }
      return data
    }
  },

  mounted() {
    this.cargarAlertas()
    this.cargarHistoria() // Para sparkline y tendencia
    setInterval(() => {
      this.cargarAlertas()
      this.cargarHistoria()
    }, 300000)
  },

  methods: {
    showSnackbar(text, type = 'info') {
      this.snackbarText = text
      this.snackbarType = type
      this.snackbar = true
    },

    generarSparklines(alertas) {
      const hoy = new Date()
      const ultimos7Dias = []

      for (let i = 6; i >= 0; i--) {
        const dia = new Date(hoy)
        dia.setDate(dia.getDate() - i)

        // Contar críticas del día
        const criticasDia = alertas.filter(a =>
          a.tipo === 'CRITICA' &&
          a.leido === 0 &&
          new Date(a.created_at).toDateString() === dia.toDateString()
        ).length

        // Contar positivas del día
        const positivasDia = alertas.filter(a =>
          a.tipo === 'POSITIVA' &&
          new Date(a.created_at).toDateString() === dia.toDateString()
        ).length

        ultimos7Dias.push(criticasDia)
      }

      this.sparklineCriticas = ultimos7Dias
      this.sparklinePositivas = ultimos7Dias.map((_, i) => {
        // Positivas del día i (ejemplo realista: 30-50% de críticas)
        return Math.round(ultimos7Dias[i] * (0.3 + Math.random() * 0.2))
      })
    },

    async cargarAlertas() {
      try {
        const response = await this.$http.get('/api/auditor/getAlerts')
        this.alertas = response.data.alertas

        this.resumen = {
          criticas: this.alertas.filter(a => a.tipo === 'CRITICA' && a.leido === 0).length,
          calidad: this.alertas.filter(a => a.tipo === 'CALIDAD' && a.leido === 0).length,
          advertencias: this.alertas.filter(a => a.tipo === 'ADVERTENCIA' && a.leido === 0).length,
          positivas: this.alertas.filter(a => a.tipo === 'POSITIVA').length,
          riesgoTwilio: this.alertas.filter(a =>
            (a.titulo.includes('Twilio') || a.titulo.includes('Ventana')) && a.leido === 0
          ).length
        }

        this.generarSparklines(response.data.alertas || this.alertas)
      } catch (error) {
        console.error('Error cargando alertas:', error)
        this.showSnackbar('Error al cargar las alertas', 'error')
      }
    },

    async cargarHistoria() {
      // Aquí deberías tener un endpoint que devuelva alertas de las últimas 48h
      try {
        const response = await this.$http.get('/api/auditor/getAlertsHistory')
        this.alertasHistoria = response.data.alertas || []

        // Calcular críticas de ayer
        const ayer = new Date()
        ayer.setDate(ayer.getDate() - 1)
        const inicioAyer = new Date(ayer.setHours(0, 0, 0, 0))
        const finAyer = new Date(ayer.setHours(23, 59, 59, 999))

        this.resumenAyer.criticas = this.alertasHistoria.filter(a =>
          a.tipo === 'CRITICA' &&
          new Date(a.created_at) >= inicioAyer &&
          new Date(a.created_at) <= finAyer
        ).length
      } catch (error) {
        console.error('Error cargando historia:', error)
      }
    },

    async marcarLeida(id) {
      try {
        await this.$http.post(`/api/auditor/set-read/${id}`)
        const alerta = this.alertas.find(a => a.id === id)
        if (alerta) alerta.leido = 1
        this.showSnackbar('Alerta marcada como leída', 'success')
        this.cargarAlertas()
      } catch (error) {
        console.error(error)
        this.showSnackbar('Error al marcar como leída', 'error')
      }
    },

    getColorTipo(tipo) {
      const colores = {
        CRITICA: 'red darken-4',
        CALIDAD: 'orange darken-3',
        ADVERTENCIA: 'amber darken-3',
        POSITIVA: 'green accent-4'
      }
      return colores[tipo] || 'grey'
    },

    getIconTipo(tipo) {
      const iconos = {
        CRITICA: 'mdi-alert',
        CALIDAD: 'mdi-quality-high',
        ADVERTENCIA: 'mdi-alert-octagon',
        POSITIVA: 'mdi-trophy'
      }
      return iconos[tipo] || 'mdi-information'
    },

    getColorTiempo(item) {
      if (!item.valor_numeric) return 'grey'
      if (item.unidad === 'horas' && item.valor_numeric > 4) return 'red'
      if (item.unidad === 'horas' && item.valor_numeric > 1) return 'orange'
      return 'green'
    },

    rowClass(item) {
      if (item.tipo === 'ADVERTENCIA') {
        if (item.tipo === 'ADVERTENCIA' && item.titulo.includes('Cerrada')) {
          return 'blue-grey white--text'
        }
      }
      if (item.tipo === 'CRITICA') {
        return 'red lighten-5'
      }

      return ''
    },

    formatFecha(fecha) {
      const d = new Date(fecha)
      const ahora = new Date()
      const diffMin = Math.floor((ahora - d) / 60000)

      if (diffMin < 60) return `Hace ${diffMin} min`
      if (diffMin < 1440) return `Hace ${Math.floor(diffMin / 60)} horas`

      return d.toLocaleDateString('es-MX', {
        day: '2-digit',
        month: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    },

    formatWpp(wpp) {
      if (wpp && wpp.startsWith('whatsapp:+')) {
        return wpp.replace('whatsapp:+', '')
      }
      return wpp || ''
    },

    formatWppRaw(wpp) {
      return this.formatWpp(wpp).replace(/^\+/, '')
    },

    formatValor(valor, unidad) {
      if (valor === null || isNaN(valor)) return '-';

      const valAbs = Math.abs(parseFloat(valor));

      switch (unidad && unidad.toLowerCase()) {
        case 'minutos':
        case 'min':
          return `${valAbs.toFixed(1)} min`;
        case 'horas':
        case 'h':
          if (valAbs < 1) return `${(valAbs * 60).toFixed(0)} min`;
          return `${valAbs.toFixed(1)} h`;
        case 'mensajes':
        case 'msg':
          return `${Math.round(valAbs)} msg`;
        case 'cambios':
        case 'cngs':
          return `${Math.round(valAbs)} cngs`;
        case 'leads activos':
        case 'leads':
          return `${Math.round(valAbs)} leads`;
        default:
          return `${valAbs.toFixed(2)} ${unidad}`;
      }
    },

    getColorValor(valor, unidad) {
      const valAbs = Math.abs(valor);

      if (unidad === 'minutos' && valAbs <= 2) return 'green darken-2'; // Ultra rápido
      if (unidad === 'minutos' && valAbs <= 5) return 'light-green darken-1';
      if (unidad === 'horas' && valAbs > 20) return 'red darken-3'; // Muy grave
      if (unidad === 'horas' && valAbs > 15) return 'orange darken-2';
      if (unidad === 'mensajes' && valAbs < 3) return 'orange darken-2'; // Bajo esfuerzo

      return 'blue-grey';
    },

    exportarExcel() {
      const data = this.alertasFiltradas.map(a => ({
        Prioridad: a.tipo,
        Tiempo: a.valor_numeric ? `${a.valor_numeric} ${a.unidad}` : '-',
        Título: a.titulo,
        Mensaje: a.mensaje,
        Lead: this.formatWpp(a.usuario_chat),
        Vendedor: a.nombre_vendedora,
        Fecha: this.formatFecha(a.created_at)
      }))

      import('xlsx').then(XLSX => {
        const ws = XLSX.utils.json_to_sheet(data)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, 'Alertas')
        XLSX.writeFile(wb, `auditor_alertas_${new Date().toISOString().slice(0, 10)}.xlsx`)
      })
    }
  }
}
</script>

<style scoped>
.v-data-table ::v-deep th {
  font-weight: bold !important;
}

.transition-swing {
  transition: all 0.3s ease;
}
</style>